import { render } from "./InlineQuestion.vue?vue&type=template&id=0612a1e8"
const script = {}

import exportComponent from "/buddy/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__